/* eslint-disable */
import * as types from 'constants/monitoreosActionTypes';
import * as services from 'services/monitoreos.service';
import {
  MONITOREOS_INTERNET,
  MONITOREOS_VISITAS_VERIFICACION,
  EVENTOS,
  CASAS,
  MONITOREOS_MEDIOS_IMPRESOS
} from 'constants/tipoMonitoreos';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { monitoreoDTO, monitoreoEventosDTO, monitoreoMediosDTO } from 'adapters/listadoMonitoreo';
import { showAlert } from 'actions/alert.actions';
import { ERROR_SAVE } from 'constants/MensajesGenerales';

export const getAllMonitoreos = (data) => async () => {
  try {
    const response = await services.fetchMonitoreos(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const getMonitoreosInternet = (page, pageSize) => async (dispatch) => {
  dispatch({ type: types.GET_MONITOREOS_INTERNET_LOADING });
  const params = {
    cantidad: pageSize,
    pagina: page,
    tipoMonitoreo: MONITOREOS_INTERNET
  };
  try {
    const { data } = await services.fetchMonitoreos(params);
    const rows = data?.monitoreos?.internet || [];
    const payload = rows.map(monitoreoDTO);
    dispatch({ type: types.GET_MONITOREOS_INTERNET_SUCCESS, payload });
    return { success: true, totalInternet: data.monitoreos.totalMonInternet };
  } catch (error) {
    dispatch({ type: types.GET_MONITOREOS_INTERNET_FAILURE, error });
    return { success: false };
  }
};

export const upsertMonitoreosInternet = (payload, pagina, pageSize) => async (dispatch) => 
{
  dispatch({ type: types.UPSERT_MONITOREOS_INTERNET_LOADING });
  try {
    const {
      data // { monitoreos, hallazgos, formatos }
    } = await services.sincronizarTodosMonitoreos(payload);
    // Buscamos que en la lista de monitoreos sincronizados exitosamente almenos venga uno
    // si no hay ninguno es que no se creo correctamente

    if (
      data.monitoreos?.synced?.length === 0 ||
      data.hallazgos?.notSynced?.length > 0 ||
      data.formatos?.notSynced?.length > 0
    ) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.UPSERT_MONITOREOS_INTERNET_FAILURE,
        error: { message: errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.UPSERT_MONITOREOS_INTERNET_SUCCESS, payload: data.monitoreos });
    dispatch(getMonitoreosInternet(pagina, pageSize));

    let returnHallazgo = {};

    if ( data?.monitoreos?.synced !== null)
    {
      //console.log('Entra primer if');
      if(data?.monitoreos?.synced[0]?.hallazgos != null)
      {
        //console.log('Entra segundo if');
        returnHallazgo = data?.monitoreos?.synced[0]?.hallazgos;
      }else{
        //console.log('Entra primer else');
        returnHallazgo = data?.hallazgos?.synced?.filter(hallazgo => 
                          Array.isArray(hallazgo.muestras) && hallazgo.muestras.length > 0
                        ) || data?.hallazgos?.synced?.[0];
      }
    }else{
      //console.log('Entra segundo else');
      returnHallazgo = data?.hallazgos?.synced?.filter(hallazgo => 
                      Array.isArray(hallazgo.muestras) && hallazgo.muestras.length > 0
                    ) || data?.hallazgos?.synced?.[0];
    }

    //console.log('returnHallazgo: ', returnHallazgo);
    /*console.log('data?.monitoreos?.synced: ', data?.monitoreos?.synced);
    console.log('data?.hallazgos?.synced[0]: ', data?.hallazgos?.synced);*/

    return {
        success: true
      /*, hallazgos:
        data?.monitoreos?.synced !== null
          ? data?.monitoreos?.synced[0]?.hallazgos
          : data?.hallazgos?.synced */
      , hallazgos: returnHallazgo
      , idMonitoreo: data?.monitoreos?.synced[0]?.id !== null
        ? data?.monitoreos?.synced[0]?.id
        : 0
    };
  } catch (error) {
    console.log('error: ', error);
    return { success: false };
  }
};

export const sendPartVideosInternet = async (
  idMuestra,
  idHallazgo,
  numeroParte,
  totalPartes,
  muestra
) => {
  try {
    const payload = {
      idMuestra,
      idHallazgo,
      numeroParte,
      totalPartes,
      muestra
    };
    await services.sincronizarFilesParts(payload);
    return { success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getMonitoreosEventos = (page, pageSize) => async (dispatch) => {
  dispatch({ type: types.GET_MONITOREOS_EVENTOS_LOADING });
  const params = {
    cantidad: pageSize,
    pagina: page,
    tipoMonitoreo: MONITOREOS_VISITAS_VERIFICACION,
    tipoVisita: EVENTOS
  };
  try {
    const { data } = await services.fetchMonitoreos(params);
    const rows = data?.monitoreos?.visitas || [];
    const payload = rows.map(monitoreoEventosDTO);
    dispatch({ type: types.GET_MONITOREOS_EVENTOS_SUCCESS, payload });
    return { success: true, totalEventos: data.monitoreos.totalVisitasEventos };
  } catch (error) {
    dispatch({ type: types.GET_MONITOREOS_EVENTOS_FAILURE, error });
    return { success: false };
  }
};

export const getMonitoreosCasas = (page, pageSize) => async (dispatch) => {
  dispatch({ type: types.GET_MONITOREOS_CASAS_LOADING });
  const params = {
    cantidad: pageSize,
    pagina: page,
    tipoMonitoreo: MONITOREOS_VISITAS_VERIFICACION,
    tipoVisita: CASAS
  };
  try {
    const { data } = await services.fetchMonitoreos(params);
    const rows = data?.monitoreos?.visitas || [];
    const payload = rows.map(monitoreoEventosDTO);
    dispatch({ type: types.GET_MONITOREOS_CASAS_SUCCESS, payload });
    return { success: true, totalCasas: data.monitoreos.totalVisitasCasas };
  } catch (error) {
    dispatch({ type: types.GET_MONITOREOS_CASAS_FAILURE, error });
    return { success: false };
  }
};

export const upsertMonitoreosEventos = (payload) => async (dispatch) => {
  dispatch({ type: types.UPSERT_MONITOREOS_EVENTOS_LOADING });
  try {
    const {
      data: { monitoreos, hallazgos, visitas }
    } = await services.sincronizarTodosMonitoreos(payload);
    // Buscamos que en la lista de monitoreos sincronizados exitosamente almenos venga uno
    // si no hay ninguno es que no se creo correctamente
    if (
      monitoreos?.synced?.length === 0 ||
      hallazgos?.notSynced?.length > 0 ||
      visitas?.notSynced?.length > 0
    ) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.UPSERT_MONITOREOS_EVENTOS_FAILURE,
        error: { message: errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.UPSERT_MONITOREOS_EVENTOS_SUCCESS, payload: monitoreos });
    dispatch(getMonitoreosEventos(payload.pagina, payload.pageSize)); // MNI - Manejo paginación
    dispatch(getMonitoreosCasas(payload.pagina, payload.pageSize)); // MNI - Manejo paginación
    return { success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getMonitoreosMediosImp = (page, pageSize) => async (dispatch) => {
  dispatch({ type: types.GET_MONITOREOS_MEDIOS_IMP_LOADING });
  const params = {
    cantidad: pageSize,
    pagina: page,
    tipoMonitoreo: MONITOREOS_MEDIOS_IMPRESOS
  };
  try {
    const { data } = await services.fetchMonitoreos(params);
    const rows = data?.monitoreos?.mediosImpresos || [];
    const payload = rows.map(monitoreoMediosDTO);
    dispatch({ type: types.GET_MONITOREOS_MEDIOS_IMP_SUCCESS, payload });
    return { success: true, totalMonMediosImpresos: data.monitoreos.totalMonMediosImpresos };
  } catch (error) {
    dispatch({ type: types.GET_MONITOREOS_MEDIOS_IMP_FAILURE, error });
    return { success: false };
  }
};

export const upsertMonitoreosMediosImp = (payload) => async (dispatch) => {
  dispatch({ type: types.UPSERT_MONITOREOS_MEDIOS_IMP_LOADING });
  try {
    const {
      data: { monitoreos, hallazgos, formatos }
    } = await services.sincronizarTodosMonitoreos(payload);
    // Buscamos que en la lista de monitoreos sincronizados exitosamente almenos venga uno
    // si no hay ninguno es que no se creo correctamente
    if (
      monitoreos?.synced?.length === 0 ||
      hallazgos?.notSynced?.length > 0 ||
      formatos?.notSynced?.length > 0
    ) {
      let errorMessage = null;
      if (hallazgos?.notSynced[0]?.code === 1013) {
        errorMessage =
          'El estatus del tipo de medio impreso es inactivo, consulte a su administrador';
      } else {
        errorMessage = 'No se ha podido guardar la información, intenta de nuevo.';
      }
      dispatch({
        type: types.UPSERT_MONITOREOS_MEDIOS_IMP_FAILURE,
        error: { message: errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.UPSERT_MONITOREOS_MEDIOS_IMP_SUCCESS, payload: monitoreos });
    dispatch(getMonitoreosMediosImp());
    return {
        success: true
      , hallazgos: monitoreos?.synced !== null ? monitoreos?.synced[0]?.hallazgos? monitoreos?.synced[0]?.hallazgos: hallazgos?.synced : hallazgos?.synced
      , idMonitoreo: monitoreos?.synced[0]?.id !== null
         ? monitoreos?.synced[0]?.id
         : 0
    };
  } catch (error) {
    console.log(error, 'error');
    return { success: false };
  }
};

export const validarHallazgosByMoni = (data) => async () => {
  try {
    const response = await services.validarHallazgosByMoni(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const getMuestrasByidMonitoreo = (data) => async () => {
  try {
    const response = await services.fetchMuestrasByIdMonitoreo(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const getImagenesByidFormato = (data) => async () => {
  try {
    const response = await services.fetchImagenesByIdFormato(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const getImagenesByidVisita = (data) => async () => {
  try {
    const response = await services.fetchImagenesByIdVisita(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const postEditMedioImp = (data) => async () => {
  try {
    const response = await services.editarMedioImp(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const postCrearMedioImp = (data) => async () => {
  try {
    const response = await services.crearMedioImp(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const postEditMonitoreo = (data) => async () => {
  try {
    const response = await services.editarMonitoreo(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const cancelMonitoring = (data) => async () => {
  try {
    const response = await services.sincronizarTodosMonitoreos(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};
